import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import { onboardingService } from '../shell/services/onboarding';
import { store } from '../store';
import WaitlistDocsUp from './WaitlistDocsUp';
import WaitlistDocsUpMobile from './WaitlistDocsUpMobile';
import { useLocation, useParams } from 'react-router-dom';
import { getThirdPartyData } from '../waitlist/services/waitlist-service';
import { setAnalyticsEvent } from '../core/helpers/analytics';
import { utils } from '../core/helpers/utils';

const WaitlistDocsUpMain = (props) => {
  const [isMobile, setIsMobile] = useState(false);
  const [pan, setPan] = useState('');
  const [email, setEmail] = useState('');
  const [previewData, setPreViewData] = useState([]);
  const location = useLocation();
  const params = useParams();
  const [thirdpartyData, setThirdpartyData] = useState({});
  const [product, setProduct] = useState();

  useEffect(() => {
    setProduct(params && params.tab);
    let mobile = window.matchMedia("(max-width: 768px)").matches;
    setIsMobile(mobile);
    getThirdPartyData({"X-product": `orobonds:default`, 'x-encrypted-data': true })
    .then((result) => {
      const thirdPartyData = JSON.parse(utils.decryptData(result));
      if (thirdPartyData && thirdPartyData.success) {
        setThirdpartyData({...thirdPartyData});
      }
    });
  }, []);

  useEffect(() => {
    setAnalyticsEvent(window.location.pathname + window.location.hash,
      "KYC_Initiated"
    );
  }, [])

  useEffect(() => {
    let email = store.getState()?.obTpd?.email || store.getState()?.user?.defaultUserDetails?.email;
  
    if (email) {
      setEmail(email);
    }
  }, [store.getState().obTpd])

  return Object.keys(thirdpartyData).length ? (
    <>
    <WaitlistDocsUp 
      email={email} 
      locationState={location.state}
      isMobile={isMobile}
      thirdpartyData={thirdpartyData}
      product={product}
    />
    <ToastContainer />
    </>) : null
}

export default WaitlistDocsUpMain